// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  bypassAuth: false,
  apiUrl: 'https://cash-flow-api-1090351846514.us-central1.run.app/api',
  firebase: {
    apiKey: 'AIzaSyCkzMvllxeMj8-7ywWBVvR6gGbCTDlazf0',
    authDomain: 'padel-reserva.firebaseapp.com',
    projectId: 'padel-reserva',
    storageBucket: 'padel-reserva.firebasestorage.app',
    messagingSenderId: '378721829684',
    appId: '1:378721829684:web:f9d52138562ab5b0141b61',
    measurementId: 'G-8RH94N1B5G',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
